export default __webpack_public_path__ + "opcoakto.72728e0.png";